import { defineMessages } from 'react-intl';

export const accessKeyMessages = defineMessages({
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    value: {
        id: 'value',
        defaultMessage: 'Value',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    passBackAllowed: {
        id: 'pass-back-allowed',
        defaultMessage: 'Pass back allowed',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    chip: {
        id: 'chip',
        defaultMessage: 'Chip',
    },
    tag: {
        id: 'tag',
        defaultMessage: 'Tag',
    },
    password: {
        id: 'password',
        defaultMessage: 'Password',
    },
    accessKeys: {
        id: 'access-keys',
        defaultMessage: 'Access keys',
    },
    keys: {
        id: 'keys',
        defaultMessage: 'Keys',
    },
    key: {
        id: 'key',
        defaultMessage: 'Key',
    },
    createAccessKeySuccess: {
        id: 'create-access-key-success',
        defaultMessage: 'Access key created',
    },
    createAccessKeySuccessDescription: {
        id: 'create-access-key-success-description',
        defaultMessage: 'A new access key has been successfully created.',
    },
    createAccessKeyModalSubtitle: {
        id: 'create-access-key-modal-subtitle',
        defaultMessage: 'Add a new access key',
    },
    deleteAccessKeySuccess: {
        id: 'delete-access-key-success',
        defaultMessage: 'Access key deleted',
    },
    deleteAccessKeySuccessDescription: {
        id: 'delete-access-key-success-description',
        defaultMessage: 'Access key {entry} has been successfully deleted.',
    },
    deleteAccessKey: {
        id: 'delete-access-key',
        defaultMessage: 'Delete access key',
    },
    deleteAccessKeySubtitle: {
        id: 'delete-access-key-subtitle',
        defaultMessage: 'Permanently delete access key {entry}',
    },
    confirmDeleteAccessKey: {
        id: 'confirm-delete-access-key',
        defaultMessage: 'Are you sure you want to delete access key {entry}? This action cannot be undone.',
    },
    editAccessKey: {
        id: 'edit-access-key',
        defaultMessage: 'Edit access key',
    },
    editAccessKeySubtitle: {
        id: 'edit-access-key-subtitle',
        defaultMessage: 'Edit access key {entry}',
    },
    updateAccessKeySuccess: {
        id: 'update-access-key-success',
        defaultMessage: 'Access key updated',
    },
    updateAccessKeySuccessDescription: {
        id: 'update-access-key-success-description',
        defaultMessage: 'Access key {entry} has been successfully updated.',
    },
});
